window.kontotypes = window.kontotypes || {};
kontotypes.ba = kontotypes.ba || {};
